import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as SetSubscriptionsActionMetadataKeys from 'automation-ui-action-features/deprecated/set-subscriptions/SetSubscriptionsActionMetadataKeys';
/**
 * @deprecated Built-in action migrated to Actions API. Keeping around for
 * backwards compatibility.
 */
export default class SetSubscriptionsActionMetadata extends Record({
  [SetSubscriptionsActionMetadataKeys.ACTION_TYPE]: ActionTypes.UPDATE_EMAIL_SUBSCRIPTION,
  [SetSubscriptionsActionMetadataKeys.SUBSCRIPTION_ID]: null,
  [SetSubscriptionsActionMetadataKeys.OPT_STATE]: null,
  [SetSubscriptionsActionMetadataKeys.LEGAL_BASIS]: null,
  [SetSubscriptionsActionMetadataKeys.LEGAL_BASIS_EXPLANATION]: null
}, 'SetSubscriptionsActionMetadata') {
  getSubscriptionId() {
    return this.get(SetSubscriptionsActionMetadataKeys.SUBSCRIPTION_ID);
  }
  getOptState() {
    return this.get(SetSubscriptionsActionMetadataKeys.OPT_STATE);
  }
  getLegalBasis() {
    return this.get(SetSubscriptionsActionMetadataKeys.LEGAL_BASIS);
  }
  getLegalBasisExplanation() {
    return this.get(SetSubscriptionsActionMetadataKeys.LEGAL_BASIS_EXPLANATION);
  }
}